import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['El protocolo exacto de 7 minutos paso a paso para usar antes de un encuentro.', 'La técnica de Bombeo Isométrico 3-2-2 para fortalecer la base.', 'El método de respiración de emergencia para anular la ansiedad de ejecución en segundos.', 'La lista de 5 alimentos económicos que actúan como precursores de flujo.', 'Guía de mantenimiento para que los resultados sean permanentes, no solo por una noche.'];
export function BenefitsSection() {
  return <section className="py-20 px-4 bg-slate-900 border-y border-slate-800" data-id="element-35">
      <div className="max-w-4xl mx-auto" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-37">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-38">
            QUÉ VAS A LOGRAR HOY
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full" data-id="element-39"></div>
        </motion.div>

        <div className="bg-slate-950 p-8 md:p-10 rounded-3xl border border-slate-800 shadow-xl" data-id="element-40">
          <ul className="space-y-6" data-id="element-41">
            {benefits.map((text, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="flex items-start gap-4" data-id="element-42">
                <CheckCircle2 className="w-6 h-6 text-blue-500 shrink-0 mt-1" data-id="element-43" />
                <span className="text-lg text-slate-300 leading-relaxed" data-id="element-44">
                  {text}
                </span>
              </motion.li>)}
          </ul>

          <div className="mt-12 flex justify-center" data-id="element-45">
            <a href="#comprar" className="flex justify-center items-center w-full max-w-md bg-blue-600 hover:bg-blue-500 text-white font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(37,99,235,0.4)] hover:shadow-[0_0_30px_rgba(37,99,235,0.6)] hover:scale-105 active:scale-95" data-id="element-46">
              Quiero Estos Resultados
            </a>
          </div>
        </div>
      </div>
    </section>;
}